/**
 * @file CustomSelect.jsx
 * @location src/components/ui/sharedui/CustomSelect.jsx
 * @role 커스텀 드롭다운 — avatar/sub/체크 표시 지원
 *
 * options: [{ value, label, sub?, avatar?, avatarText? }]
 */
import { useState, useEffect, useRef } from 'react';
import { Icon } from '../Icon.jsx';

/**
 * @param {object} props
 * @param {string} props.value
 * @param {(v: string) => void} props.onChange
 * @param {Array<{ value: string, label: string, sub?: string, avatar?: string, avatarText?: string }>} props.options
 * @param {number} [props.minWidth]
 */
export function CustomSelect({ value, onChange, options, minWidth }) {
  const [open, setOpen] = useState(false);
  const ref     = useRef(null);
  const current = options.find(o => o.value === value);

  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="csel" ref={ref} style={minWidth ? { minWidth } : {}}>
      <button
        className={`csel-trigger${open ? ' open' : ''}`}
        onClick={() => setOpen(v => !v)}
      >
        {current?.avatar && (
          <span className={`csel-av ${current.avatar}`}>{current.avatarText}</span>
        )}
        <span className="csel-val">{current?.label ?? ''}</span>
        <svg className={`csel-chevron${open ? ' up' : ''}`} width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {open && (
        <div className="csel-panel">
          {options.map(o => {
            const isSel = o.value === value;
            return (
              <button
                key={o.value}
                className={`csel-opt${isSel ? ' sel' : ''}`}
                onClick={() => { onChange(o.value); setOpen(false); }}
              >
                {o.avatar
                  ? <span className={`csel-av ${o.avatar}`}>{o.avatarText}</span>
                  : <span className="csel-check-wrap">
                      {isSel && <span className="csel-check"><Icon name="check" size={12} /></span>}
                    </span>
                }
                <span className="csel-opt-label">{o.label}</span>
                {o.sub && <span className="csel-opt-sub">{o.sub}</span>}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
